var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('BaseBreadcrumb',{attrs:{"title":this.$vuetify.lang.t('$vuetify.REPORTS.TITLE'),"breadcrumbs":[
      {
        text: this.$vuetify.lang.t('$vuetify.REPORTS.DESCRIPTION'),
        disabled: true
      }
    ]}}),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-tabs',{model:{value:(_vm.selectedPage),callback:function ($$v) {_vm.selectedPage=$$v},expression:"selectedPage"}},[(
              _vm.user.isAdmin ||
                (_vm.user.isPlaceAdmin && !_vm.user.isWhitelistManager) ||
                _vm.isGlobalAdmin ||
                _vm.user.isPlaceAdmin
            )?_c('v-tab',[_vm._v(" Payout ")]):_vm._e(),(
              _vm.user.isAdmin || _vm.user.isPlaceAdmin || _vm.user.isWhitelistManager
            )?_c('v-tab',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.WHITELISTS.TITLE'))+" ")]):_vm._e(),_c('v-tab',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.FLEETS.TITLE'))+" ")]),(
              _vm.user.isAdmin ||
                (_vm.user.isPlaceAdmin && !_vm.user.isWhitelistManager) ||
                _vm.isGlobalAdmin ||
                _vm.user.isPlaceAdmin
            )?_c('v-tab-item',[_c('payout-report')],1):_vm._e(),(
              _vm.user.isAdmin || _vm.user.isPlaceAdmin || _vm.user.isWhitelistManager
            )?_c('v-tab-item',[_c('whitelist-report')],1):_vm._e(),_c('v-tab-item',[_c('fleet-report')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }